import AdminNavMain from "./AdminNavComponent";
import AdminStats from "./AdminStatsComponent";

function AdminMain(){
    return(
        <>
            <AdminNavMain />
            <AdminStats />
        </>
    )
}

export default AdminMain